// assets/edm-bundle-ui-render-desktop.js
// Desktop-spezifische Rendering-Funktionen (Badges, Summary, Spinner)
// Context7: Platform Separation - Shared functions moved to UIRenderShared
// NOTE: renderSlots(), ensureSlotImg(), getSlotLabelText(), showToast() are now in UIRenderShared

window.EdumonBundle = window.EdumonBundle || {};

window.EdumonBundle.UIRenderDesktop = {
  // Cache für vorherige Mengen pro Variante (für Badge-Animationen)
  _prevQtyByVid: new Map(),
  _lastTierQty: 0,
  
  /**
   * Render slots (Delegates to UIRenderShared)
   * Context7: Platform Separation - Shared logic moved to UIRenderShared
   * This is a wrapper for backward compatibility
   * 
   * @param {Object} state - State object with items
   * @param {Array} slots - Slot elements
   * @param {Map} cardImgByVid - Map of variantId -> img element
   * @param {Array} tiers - Discount tiers
   * @param {Function} getSlotLabelText - Function to get slot label text
   */
  renderSlots: function(state, slots, cardImgByVid, tiers, getSlotLabelText) {
    const UIRenderShared = window.EdumonBundle.UIRenderShared;
    if (UIRenderShared && UIRenderShared.renderSlots) {
      return UIRenderShared.renderSlots(state, slots, cardImgByVid, tiers, getSlotLabelText);
    }
    console.warn('[Bundle Builder] UIRenderShared.renderSlots not available');
  },
  
  /**
   * Get slot label text (Delegates to UIRenderShared)
   * Context7: Platform Separation - Shared logic moved to UIRenderShared
   * This is a wrapper for backward compatibility
   * 
   * @param {number} idx - Slot index
   * @param {Array} tiers - Discount tiers
   * @returns {string} Label text
   */
  getSlotLabelText: function(idx, tiers) {
    const UIRenderShared = window.EdumonBundle.UIRenderShared;
    if (UIRenderShared && UIRenderShared.getSlotLabelText) {
      return UIRenderShared.getSlotLabelText(idx, tiers);
    }
    console.warn('[Bundle Builder] UIRenderShared.getSlotLabelText not available');
    return String(idx);
  },
  
  
  /**
   * Render badges (Desktop-only)
   * Context7: Platform Separation - Badges are hidden on mobile via CSS (.bb__grid { display:none })
   * This function should only be called on Desktop
   * 
   * @param {Object} state - State object with items
   * @param {Array} cards - Card elements
   */
  renderBadges: function(state, cards) {
    const Config = window.EdumonBundle.Config;
    const SELECTORS = Config.SELECTORS;
    const CLASSES = Config.CLASSES;
    const DATA_ATTRS = Config.DATA_ATTRS;
    
    const pulse = (el) => {
      el.classList.remove(CLASSES.PULSE, CLASSES.OUT);
      void el.offsetWidth; // reflow zum Neustarten
      el.classList.add(CLASSES.PULSE);
    };
    
    const popOut = (el, onDone) => {
      el.classList.remove(CLASSES.PULSE);
      const token = String(performance.now() + Math.random());
      el.setAttribute(DATA_ATTRS.BB_OUT_TOKEN, token);
      
      el.classList.add(CLASSES.OUT);
      const finish = () => {
        if (el.getAttribute(DATA_ATTRS.BB_OUT_TOKEN) === token) {
          el.classList.remove(CLASSES.OUT);
          el.hidden = true; // erst nach der Animation verstecken
          el.textContent = ''; // keine „0" im DOM lassen
        }
        el.removeEventListener('animationend', finish);
        if (onDone) onDone();
      };
      el.addEventListener('animationend', finish, { once: true });
    };
    
    for (const card of cards) {
      const vid = card.dataset.variantId;
      const qty = state.items[vid] || 0;
      const prev = this._prevQtyByVid.get(vid) || 0;
      const badge = card.querySelector(SELECTORS.BADGE);
      if (!badge) continue;
      
      // Falls Out läuft aber jetzt wieder >0: abbrechen & zeigen
      if (qty > 0 && badge.classList.contains(CLASSES.OUT)) {
        badge.classList.remove(CLASSES.OUT);
        badge.setAttribute(DATA_ATTRS.BB_OUT_TOKEN, '');
        badge.hidden = false;
      }
      
      // === 0: nie „0" zeigen ===
      if (qty === 0) {
        if (prev > 0 && !badge.hidden) {
          // mit Out-Animation ausblenden, DANACH wirklich entfernen
          badge.classList.remove(CLASSES.PULSE);
          const token = String(performance.now() + Math.random());
          badge.setAttribute(DATA_ATTRS.BB_OUT_TOKEN, token);
          badge.classList.add(CLASSES.OUT);
          
          const finish = () => {
            if (badge.getAttribute(DATA_ATTRS.BB_OUT_TOKEN) === token) {
              badge.classList.remove(CLASSES.OUT);
              badge.textContent = ''; // keine „0" im DOM
              badge.setAttribute('aria-hidden', 'true');
              badge.hidden = true; // triggert unser CSS [hidden]{display:none}
              badge.style.display = 'none'; // Hard-Fallback gegen Theme-Overrides
            }
            badge.removeEventListener('animationend', finish);
          };
          badge.addEventListener('animationend', finish, { once: true });
        } else {
          // ohne vorherige Zahl: sofort komplett weg
          badge.classList.remove(CLASSES.PULSE, CLASSES.OUT);
          badge.textContent = '';
          badge.setAttribute('aria-hidden', 'true');
          badge.hidden = true;
          badge.style.display = 'none';
        }
        
        this._prevQtyByVid.set(vid, qty);
        continue;
      }
      
      // === >0: zeigen + pulsen ===
      const needsUnhide =
        badge.hidden ||
        badge.style.display === 'none' ||
        badge.getAttribute('aria-hidden') === 'true' ||
        badge.classList.contains(CLASSES.OUT);
      
      const nextText = String(qty);
      const textChanged = badge.textContent !== nextText;
      
      if (needsUnhide) {
        badge.hidden = false; // entfernt [hidden]
        badge.style.display = ''; // inline display:none zurücksetzen
        badge.removeAttribute('aria-hidden');
        badge.classList.remove(CLASSES.OUT); // evtl. laufende Out-Anim abbrechen
        badge.setAttribute(DATA_ATTRS.BB_OUT_TOKEN, ''); // Token invalidieren
      }
      
      if (textChanged) badge.textContent = nextText;
      
      if (needsUnhide) {
        // sauberer Reflow, damit die Pulse-Anim sicher startet
        void badge.offsetWidth;
        requestAnimationFrame(() => {
          badge.classList.remove(CLASSES.PULSE);
          badge.classList.add(CLASSES.PULSE);
        });
      } else if (textChanged) {
        badge.classList.remove(CLASSES.PULSE);
        badge.classList.add(CLASSES.PULSE);
      }
      
      this._prevQtyByVid.set(vid, qty);
    }
  },
  
  /**
   * Render summary (Desktop elements + Mobile Hooks)
   * Context7: Platform Separation - Desktop elements (hint, total, est, submit) are hidden on mobile via CSS
   * BUT: This function also triggers Mobile Hooks (sticky, sheet summary) via Controller callbacks
   * Therefore it's called on both platforms, but only Desktop elements are rendered here
   * 
   * @param {Object} state - State object
   * @param {Array} tiers - Discount tiers
   * @param {Object} priceMap - Price map {variantId: price}
   * @param {number} unitPrice - Unit price fallback
   * @param {string} moneyFormat - Money format string
   * @param {Array} slots - Slot elements
   * @param {Element} hintEl - Hint element (Desktop-only, hidden on mobile)
   * @param {Element} totalEl - Total element (Desktop-only, hidden on mobile)
   * @param {Element} estEl - Estimated element (Desktop-only, hidden on mobile)
   * @param {Element} submitEl - Submit button element (Desktop-only, hidden on mobile)
   * @param {Function} computeHintWithContext - Function to compute hint text
   * @param {Map} tierBySlot - Map of slot index -> discount
   */
  renderSummary: function(state, tiers, priceMap, unitPrice, moneyFormat, slots, hintEl, totalEl, estEl, submitEl, computeHintWithContext, tierBySlot) {
    const Config = window.EdumonBundle.Config;
    const Utils = window.EdumonBundle.Utils;
    const Analytics = window.EdumonBundle.Analytics;
    const SELECTORS = Config.SELECTORS;
    const CLASSES = Config.CLASSES;
    
    // Hint
    if (hintEl) {
      const html = computeHintWithContext(state.totalQty);
      if (hintEl.innerHTML !== html) hintEl.innerHTML = html;
    }
    
    // Tier-Visualisierung in Slots
    let currentTier = null;
    for (const t of tiers) if (state.totalQty >= t.qty) currentTier = t;
    for (const slot of slots) {
      const idx = parseInt(slot.dataset.slot, 10);
      const off = tierBySlot.get(idx);
      const shout = slot.querySelector(SELECTORS.SHOUT);
      const isCurrent = !!currentTier && off === currentTier.off && idx === currentTier.qty;
      const reached = state.totalQty >= idx;
      
      slot.classList.toggle(CLASSES.TIER_CURRENT, isCurrent);
      slot.classList.toggle(CLASSES.TIER_REACHED, reached && !isCurrent);
      
      if (typeof off !== 'undefined') {
        if (isCurrent) {
          const text = Config.TEXTS.TIER_REACHED(off);
          if (shout) {
            if (shout.textContent !== text) shout.textContent = text;
            if (shout.hidden) {
              shout.hidden = false;
              shout.setAttribute('aria-label', Config.TEXTS.ARIA_TIER_REACHED(off, idx));
            }
          }
        } else if (shout && !shout.hidden) {
          shout.hidden = true;
          shout.removeAttribute('aria-label');
        }
      }
    }
    
    if (currentTier && currentTier.qty !== this._lastTierQty) {
      this._lastTierQty = currentTier.qty;
      Analytics.trackTierReached(currentTier.qty, currentTier.off);
      const slot = slots.find(s => parseInt(s.dataset.slot, 10) === currentTier.qty);
      slot?.classList.add(CLASSES.JUST_EARNED);
      setTimeout(() => slot?.classList.remove(CLASSES.JUST_EARNED), 800);
    }
    
    if (totalEl) totalEl.textContent = state.totalQty;
    
    if (estEl) {
      const estSubtotal = Object.entries(state.items)
        .reduce((sum, [vid, qty]) => sum + (priceMap[vid] || unitPrice) * qty, 0);
      const estDiscount = state.tier ? Math.round(estSubtotal * state.tier.off / 100) : 0;
      const estTotal = estSubtotal - estDiscount;
      const html = state.totalQty
        ? `${Utils.fmtMoney(estTotal, moneyFormat)} <span class="bb__est-note">(−${state.tier ? state.tier.off : 0}% voraussichtlich)</span>`
        : '';
      if (estEl.innerHTML !== html) estEl.innerHTML = html;
    }
    if (submitEl) submitEl.disabled = state.totalQty === 0;
  },
  
  /**
   * Toggle loading spinner on add-to-cart button
   * Context7: UI Feedback - Provides visual feedback during async operations
   * DESKTOP FIX: Spinner wird direkt im Button angezeigt (nicht unterhalb)
   * 
   * @param {boolean} isLoading - Whether to show or hide spinner
   * @param {Element|null} form - Optional form element (if null, uses Utils.findATC())
   */
  toggleSpinner: function(isLoading, form = null) {
    const Config = window.EdumonBundle.Config;
    const Utils = window.EdumonBundle.Utils;
    
    // Find ATC button - prefer form parameter, fallback to Utils.findATC()
    let btn = null;
    if (form) {
      btn = form.querySelector(Config.SELECTORS.ATC_BUTTON);
    } else {
      btn = Utils.findATC();
    }
    
    if (!btn) return;
    
    // DESKTOP FIX: Spinner muss direkt im Button sein (nicht in parent)
    // Prüfe zuerst im Button nach beiden möglichen Klassen
    let spinner = btn.querySelector('.loading__spinner') || 
                  btn.querySelector('.loading-overlay__spinner') || 
                  btn.querySelector(Config.SELECTORS.LOADING_SPINNER);
    
    // Fallback: Suche in parent (product-form) für bestehende Implementierungen
    if (!spinner) {
      const host = btn.closest('product-form') || btn.parentElement;
      if (host) {
        spinner = host.querySelector('.loading__spinner') || 
                  host.querySelector('.loading-overlay__spinner') || 
                  host.querySelector(Config.SELECTORS.LOADING_SPINNER);
      }
    }
    
    if (!spinner) {
      // DESKTOP FIX: Spinner direkt im Button erstellen
      // Verwende .loading__spinner (Standard) für bessere Kompatibilität mit base.css
      spinner = document.createElement('div');
      spinner.className = 'loading__spinner hidden';
      spinner.setAttribute('aria-hidden', 'true');
      // DESKTOP FIX: SVG-Größe an Button anpassen (1.8rem = ~28.8px, viewBox 0 0 66 66)
      spinner.innerHTML = `
        <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" style="width: 1.8rem; height: 1.8rem;">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>`;
      
      // DESKTOP FIX: Spinner direkt im Button anfügen (nicht in parent)
      btn.appendChild(spinner);
      
      // DESKTOP FIX: Sicherstellen dass Button position: relative hat (für absolute positioning)
      const btnStyle = getComputedStyle(btn);
      if (btnStyle.position === 'static') {
        btn.style.position = 'relative';
      }
    } else {
      // DESKTOP FIX: Wenn Spinner existiert, aber in parent ist, in Button verschieben
      if (spinner.parentElement !== btn) {
        btn.appendChild(spinner);
      }
      // DESKTOP FIX: Klasse auf .loading__spinner normalisieren (falls .loading-overlay__spinner)
      if (spinner.classList.contains('loading-overlay__spinner')) {
        spinner.classList.remove('loading-overlay__spinner');
        spinner.classList.add('loading__spinner');
      }
      // DESKTOP FIX: SVG-Größe sicherstellen
      const svg = spinner.querySelector('.spinner');
      if (svg && !svg.style.width) {
        svg.style.width = '1.8rem';
        svg.style.height = '1.8rem';
      }
    }
    
    if (isLoading) {
      btn.classList.add('loading');
      btn.setAttribute('aria-busy', 'true');
      spinner.classList.remove('hidden');
      spinner.removeAttribute('aria-hidden');
    } else {
      btn.classList.remove('loading');
      btn.removeAttribute('aria-busy');
      spinner.classList.add('hidden');
      spinner.setAttribute('aria-hidden', 'true');
    }
  },
  
  /**
   * Show toast notification (Delegates to UIRenderShared)
   * Context7: Platform Separation - Shared logic moved to UIRenderShared
   * This is a wrapper for backward compatibility
   * 
   * @param {string} message - Message to display
   * @param {string} type - Type: 'error' (default) or 'success'
   */
  showToast: function(message, type = 'error') {
    const UIRenderShared = window.EdumonBundle.UIRenderShared;
    if (UIRenderShared && UIRenderShared.showToast) {
      return UIRenderShared.showToast(message, type);
    }
    console.warn('[Bundle Builder] UIRenderShared.showToast not available');
  }
};

// Cleanup: Pulse-Flag automatisch wieder aufräumen
document.addEventListener('animationend', (e) => {
  if (e.target.matches('.bb__badge.is-pulse')) {
    e.target.classList.remove('is-pulse');
  }
});
